import React from "react";

import SingleProspectContent from "../components/prospects/single-prospect-content";

const SingleProspect = () => {
  return <SingleProspectContent />;
};

export default SingleProspect;
